export const jsonTransformer = {
  from: <TModel>(value: string) => JSON.parse(value) as TModel,
  to: <TModel>(value: TModel) => JSON.stringify(value),
};

export type LocalStorageCollectionFieldAccessor<TModel, TField extends keyof TModel> = {
  get: () => TModel[TField];
  set: (value: TModel[TField]) => void;
  remove: () => void;
};

export const createLocalStorageCollectionFieldAccessor = <TModel, TField extends keyof TModel>(
  collectionKey: string,
  fieldKey: TField,
  defaultValue: TModel[TField],
  construct: (value: unknown) => TModel[TField],
) => ({
  get: () => {
    const collection = localStorage.getItem(collectionKey);

    if (!collection) {
      return defaultValue;
    }

    const records = jsonTransformer.from<TModel>(collection);
    return construct(records[fieldKey] ?? defaultValue);
  },

  set: (value: TModel[TField]) => {
    const collection = localStorage.getItem(collectionKey) ?? jsonTransformer.to({});

    const records = jsonTransformer.from<TModel>(collection);
    records[fieldKey] = value;

    localStorage.setItem(collectionKey, jsonTransformer.to(records));
  },

  remove: () => {
    const collection = localStorage.getItem(collectionKey) ?? jsonTransformer.to({});

    const records = jsonTransformer.from<TModel>(collection);
    delete records[fieldKey];

    localStorage.setItem(collectionKey, jsonTransformer.to(records));
  },
});
